import PaymentProfiles from 'modules/Finance/PaymentProfiles/List/PaymentProfiles'
import Reducer from 'modules/Finance/PaymentProfiles/List/reducer'

export default PaymentProfiles

export { Reducer }
